import { DesignEntity } from '@/lib/enums';

const DEFAULT_OPTIONS = {
  includeBudget: true,
  includeCost: true,
  includeTags: true,
  includeSpan: false,
  includePeople: false,
};

const defaultMetricGroup = (metricOptions) => {
  const options = {
    ...DEFAULT_OPTIONS,
    ...metricOptions,
  };

  const metrics = {
    count: 0,
    cost: 0,
    groups: 0,
    roles: 0,
    managers: 0,
    activities: 0,
    hours: 0,
    people: 0,
    allocatedFTE: 0,
    fte: 0,
    budget: 0,
  };

  if (options.includeCost) {
    metrics.cost = 0;
  }

  if (options.includeBudget) {
    metrics.budget = 0;
  }

  if (options.includeSpan) {
    metrics.span = 0;
  }

  if (options.includeTags) {
    metrics.tags = {
      [DesignEntity.ACTIVITY]: {},
      [DesignEntity.GROUP]: {},
      [DesignEntity.ROLE]: {},
    };
  }

  return metrics;
};

export default defaultMetricGroup;
